import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isMarkAsReadOptionDirty(state) {
    var savedOptions = state.userOptions;
    var behavior = getFallbackValueIfNull(state.optionState.behavior, savedOptions.PreviewMarkAsRead);
    var delay = getFallbackValueIfNull(state.optionState.delay, savedOptions.MarkAsReadDelaytime);
    return (behavior !== savedOptions.PreviewMarkAsRead ||
        (behavior === 'Delayed' && delay !== savedOptions.MarkAsReadDelaytime));
});
//# sourceMappingURL=isMarkAsReadOptionDirty.js.map